import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IBooth, IColors, ICustomApp, ITradeFair } from '@sv/interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { TradefairService } from 'src/app/_services/_content/_TradeFair/tradefair.service';
import { BoothAnalyticsService } from 'src/app/_services/_analytics/booth-analytics.service';
import SwiperCore, { Mousewheel, Navigation, Pagination, Swiper } from 'swiper/core';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BoothOverviewComponent } from '../booth-overview/booth-overview.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AgreeDataCollectionComponent } from './agree-data-collection/agree-data-collection.component';
import { TicketcodeAuthService } from 'src/app/_services/_auth/ticketcode-auth.service';
import { AttendeesService } from 'src/app/_services/_auth/attendees.service';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable, of } from 'rxjs';
import { LoginService } from 'src/app/_services/_content/login.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { EventAnalyticsService } from 'src/app/_services/_analytics/event-analytics.service';

// install Swiper components
// access to slider to invoke methods
/* const el: any = document.querySelector('.swiper-container');
      const swiper: Swiper = el.swiper; */
SwiperCore.use([Navigation, Pagination, Mousewheel]);

@Component({
  selector: 'app-tradefair-overview',
  templateUrl: './tradefair-overview.component.html',
  styleUrls: ['./tradefair-overview.component.scss']
})
export class TradefairOverviewComponent implements OnInit, OnDestroy, AfterViewInit {
  loaded = false;
  currentSlide: number;
  currentOpenDialog: MatDialogRef<BoothOverviewComponent>;
  boothOpen = false;
  searchValue = '';
  separatorKeysCodes: number[] = [ENTER, COMMA];

  // https://swiperjs.com/swiper-api
  constructor(
    private fairService: TradefairService,
    private bottomSheet: MatBottomSheet,
    private boothAnalyticsService: BoothAnalyticsService,
    private customAppService: CustomAppService,
    private matDialog: MatDialog,
    private authService: TicketcodeAuthService,
    private attendeeService: AttendeesService,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private router: Router,
    private ngZone: NgZone,
    private eventAnalyticsService: EventAnalyticsService
  ) {
    this.tagsCtrl.valueChanges.subscribe((search) => {
      this.filteredTags = of(this.availableTags.filter((tag) => tag.toLowerCase().includes(search)));
    });
  }

  ngAfterViewInit(): void {
    const top = document.getElementById('top');
    if (top) {
      setTimeout(() => {
        top.scrollIntoView();
      }, 1);
    }

    /* const button = document.getElementsByClassName('swiper-button-disabled');
    if (button[0] && button[1]) {
      button[0].addEventListener('click', (event: any) => {
        if (event.target.classList && this.toArray(event.target.classList).includes('swiper-button-disabled')) {
          this.navigateEnds();
        }
      });
      button[1].addEventListener('click', (event: any) => {
        if (event.target.classList && this.toArray(event.target.classList).includes('swiper-button-disabled')) {
          this.navigateEnds();
        }
      });
    } */
  }

  fair: ITradeFair;
  customApp: ICustomApp;
  colors: IColors;
  swiperBooths: IBooth[];
  @ViewChild('swiperDetail') swiperDetail;
  @ViewChild('swiperOverview') swiperOverview: Swiper;

  attendeeId: string;

  tagsCtrl = new FormControl();
  filteredTags: Observable<string[]>;
  searchedTags: string[] = [];
  availableTags: string[] = [];
  searchText: string;

  @ViewChild('tagsInput') tagsInput: ElementRef<HTMLInputElement>;
  @ViewChild('tagsAutoFill') matAutocomplete: MatAutocomplete;

  mobile = false;

  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 699;
  }

  ngOnInit(): void {
    this.mobile = document.documentElement.clientWidth < 699;
    this.customAppService.getCustomAppListener().subscribe(async (app) => {
      this.customApp = app;
      this.colors = this.customApp.colors as IColors;
      this.fairService.getFairListener().subscribe(async (fair) => {
        const boothId = this.route.snapshot.queryParamMap.get('boothId');
        const overview = this.route.snapshot.queryParamMap.get('boothOverview');

        this.fair = fair;
        this.availableTags = this.fair.settings.availableTags;
        this.searchText = fair.settings.searchText ?? 'Search Booths';
        this.customAppService.setExpoActive(this.searchText);

        this.swiperBooths = this.fair.booths;
        this.currentSlide = 0;

        if (boothId) {
          const boothIndex = this.swiperBooths.findIndex((booth) => booth._id === boothId);
          if (boothIndex !== -1) {
            this.currentSlide = boothIndex;
            this.router.navigate(['.'], { relativeTo: this.route, queryParams: { bootId: null } });
            if (!overview) {
              this.switch(this.swiperBooths[boothIndex]);
            }
          }
        }
        // should never happen, just a backup
        if (typeof this.customApp.login === 'string') {
          this.customApp.login = await this.loginService.getLoginById(this.customApp.login);
        }
        if (this.customApp.login.enabled && this.fair.settings.personalizedAnalytics && localStorage.getItem('dataUsage') !== 'true') {
          const agreed = await this.bottomSheet
            .open(AgreeDataCollectionComponent, {
              data: { text: this.fair.settings.agreeText, buttonText: this.fair.settings.agreeButtonText },
              hasBackdrop: true,
              disableClose: true,
              closeOnNavigation: true
            })
            .afterDismissed()
            .toPromise();
          const attendee = this.authService.decodeToken();
          if (attendee !== undefined) {
            this.attendeeId = attendee._id;
          }
          if (agreed) {
            await this.attendeeService.recordUserConsent(this.attendeeId);
          }
          localStorage.setItem('dataUsage', agreed);
        }
        this.loaded = true;

        this.customAppService.getboothSearchValue().subscribe((val) => {
          if (val) {
            this.searchValue = val;
          } else {
            this.searchValue = '';
          }
          this.searchBooths();
        });
      });
    });
  }

  addTagFilter(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      if (this.availableTags.includes(value)) {
        this.searchedTags.push(value);
        event.input.value = '';
        this.tagsCtrl.setValue(null);
        this.tagsCtrl.updateValueAndValidity();
        this.searchValue = '';
        this.searchBooths();
      }
    }
  }

  removeTagFilter(tag: string): void {
    const index = this.searchedTags.indexOf(tag);

    if (index >= 0) {
      this.searchedTags.splice(index, 1);
      this.searchBooths();
    }
  }

  selectedTagOption(event: MatAutocompleteSelectedEvent): void {
    this.searchedTags.push(event.option.viewValue);
    this.searchBooths();
    this.tagsInput.nativeElement.value = '';
    this.tagsCtrl.setValue('');
    this.tagsCtrl.updateValueAndValidity();
    this.searchText = '';
  }

  filterBooths() {
    const tags = this.searchedTags;

    const filterdBooths = this.fair.booths.filter((booth) => {
      const boothTags = booth.settings.selectedTags;
      let found = false;
      for (const tag of tags) {
        if (boothTags.includes(tag)) {
          found = true;
          break;
        }
      }
      return found;
    });

    return filterdBooths;
  }

  searchBooths(fromControl?: boolean) {
    if (fromControl) {
      this.searchValue = this.tagsCtrl.value;
    }
    let filteredBooths = [];
    // filter set; filter has priority over all other searches
    if (this.searchedTags.length > 0) {
      filteredBooths = this.filterBooths();
      filteredBooths = filteredBooths.filter((booth) => {
        const boothName = booth.settings.name.toLowerCase();
        return boothName.includes(this.searchValue?.toLowerCase());
      });
    } else {
      filteredBooths = this.fair.booths.filter((booth) => {
        const boothName = booth.settings.name.toLowerCase();
        return boothName.includes(this.searchValue?.toLowerCase());
      });
    }

    if (filteredBooths) {
      this.swiperBooths = filteredBooths;
    }
  }

  async onSlideChange(event) {
    const booth = this.swiperBooths[event.realIndex];
    if (this.boothOpen && this.currentOpenDialog.id !== booth._id) {
      this.matDialog.closeAll();
      this.currentOpenDialog.close(true);
      this.ngZone.run(() => {
        this.currentOpenDialog.close();
        this.matDialog.closeAll();
      });
      // otherwise double open if no dialog was open before
      if (this.matDialog.openDialogs[0].id !== booth._id) {
        this.currentSlide = event.realIndex;
        this.boothAnalyticsService.startDuration(booth._id);
        if (!this.mobile) {
          this.currentOpenDialog = this.matDialog.open(BoothOverviewComponent, {
            id: booth._id,
            data: { boothId: booth._id },
            hasBackdrop: false,
            closeOnNavigation: true,
            width: '90%',
            maxWidth: '1100px',
            panelClass: 'boothDialog'
          });
        } else {
          this.matDialog.open(BoothOverviewComponent, {
            data: { boothId: booth._id },
            hasBackdrop: false,
            closeOnNavigation: true,
            height: '100vh',
            width: '100vw',
            panelClass: 'boothDialog'
          });
        }

        /* if (this.fair.settings.personalizedAnalytics && localStorage.getItem('dataUsage') === 'true') {
          this.boothAnalyticsService.newBoothView(booth._id, this.attendeeId);
        } else {
          this.boothAnalyticsService.newBoothView(booth._id);
        } */
      }
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') {
      this.onLeft();
    }
    if (event.key === 'ArrowRight') {
      this.onRight();
    }
  }

  toArray(obj) {
    const array = [];
    // iterate backwards ensuring that length is an UInt32
    // tslint:disable-next-line:no-bitwise
    for (let i = obj.length >>> 0; i--; ) {
      array[i] = obj[i];
    }
    return array;
  }

  navigateEnds() {
    const el: any = document.querySelector('.swiper-container');
    const swiper: Swiper = el.swiper;
    // to buggy to release, is beginning is set to fast so the first slide is skipped on navigation from the second slide
    /* if (swiper.isBeginning && !this.dontSwipe) {
      swiper.slideTo(this.swiperBooths.length - 1);
    } else */

    if (swiper.isEnd) {
      swiper.slideTo(0);
    }
    // to buggy to release
    /* if (this.dontSwipe) {
      this.dontSwipe = false;
    } */
  }

  onLeft() {
    const el: any = document.querySelector('.swiper-container');
    const swiper: Swiper = el.swiper;
    swiper.isBeginning ? swiper.slideTo(this.swiperBooths.length - 1) : swiper.slidePrev();
  }

  onRight() {
    const el: any = document.querySelector('.swiper-container');
    const swiper: Swiper = el.swiper;
    swiper.isEnd ? swiper.slideTo(0) : swiper.slideNext();
  }

  async switch(booth: IBooth) {
    if (!this.mobile) {
      const index = this.swiperBooths.findIndex((arrBooth) => arrBooth._id === booth._id);
      const alreadOpen = this.matDialog.openDialogs[0] ? this.matDialog.openDialogs[0].id === booth._id : false;
      if (index === this.currentSlide && !alreadOpen) {
        this.boothAnalyticsService.startDuration(booth._id);
        this.currentOpenDialog?.close();
        this.matDialog.closeAll();
        /* if (this.fair.settings.personalizedAnalytics && localStorage.getItem('dataUsage') === 'true') {
        this.boothAnalyticsService.newBoothView(booth._id, this.attendeeId);
      } else {
        this.boothAnalyticsService.newBoothView(booth._id);
      } */
        this.currentSlide = index;
        if (!this.mobile) {
          this.currentOpenDialog = this.matDialog.open(BoothOverviewComponent, {
            id: booth._id,
            data: { boothId: booth._id },
            hasBackdrop: false,
            closeOnNavigation: true,
            width: '90%',
            maxWidth: '1100px',
            panelClass: 'boothDialog'
          });
        } else {
          this.matDialog.open(BoothOverviewComponent, {
            data: { boothId: booth._id },
            hasBackdrop: false,
            closeOnNavigation: true,
            height: '100%',
            width: '100%',
            maxHeight: '100vh',
            panelClass: 'boothDialog'
          });
        }
        this.boothOpen = true;
        this.matDialog.afterAllClosed.subscribe(() => {
          this.boothOpen = false;
          this.searchBooths();
        });
      } else if (index > this.currentSlide) {
        const el: any = document.querySelector('.swiper-container');
        const swiper: Swiper = el.swiper;
        swiper.slideNext();
      } else {
        const el: any = document.querySelector('.swiper-container');
        const swiper: Swiper = el.swiper;
        swiper.slidePrev();
      }
    } else {
      this.boothAnalyticsService.startDuration(booth._id);
      this.currentOpenDialog = this.matDialog.open(BoothOverviewComponent, {
        id: booth._id,
        data: { boothId: booth._id },
        hasBackdrop: false,
        closeOnNavigation: true,
        autoFocus: true,
        width: '90%',
        maxWidth: '1100px',
        panelClass: 'boothDialog'
      });
    }
  }

  scrollToTop(): void {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }

  async ngOnDestroy(): Promise<void> {
    this.matDialog.closeAll();
    this.bottomSheet.dismiss();
    // for mobile search
    this.customAppService.setExpoActive(undefined);
    this.customAppService.pushNewSearchValue('');
    await this.eventAnalyticsService.newCollectionRoomView();
  }
}
